// import AreaControlError from "../Charts/AreaControlError";
import AncillaryServicesMCP from '../Charts/AncillaryServicesMCP';
import CoordinatedTransactionScheduling from '../Charts/CoordinatedTransactionScheduling';
import ExAnteLmp from '../Charts/ExAnteLmp';
import LmpConsolidatedTable from '../Charts/LmpConsolidatedTable';
import LMPContourMap from '../Charts/LMPContourMap';
import RealTimeBindingConstraints from '../Charts/RealTimeBindingConstraints';
import RealTimeRSGCommitments from '../Charts/RealTimeRSGCommitments';
import ReserveProductsBindingConstraints from '../Charts/ReserveProductsBindingConstraints';
import SubRegionalPowerBalanceBindingConstraints from '../Charts/SubRegionalPowerBalanceBindingConstraints';

import Disclaimer from '../Components/Disclaimer';
import Pod from '../Components/Pod';

export default function MarketDisplays() {
	return (
		<>
			<div className='podContainer'>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='LMP Contour Map' Chart={LMPContourMap} showPopout={true} hideDisclaimer={true} removeChartArea={true} hideDownload={true} />
					</div>
					<div className='column-2'>
						<Pod title='ExAnte LMP' Chart={ExAnteLmp} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='Real-Time Binding Constraints' Chart={RealTimeBindingConstraints} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='LMP Consolidated Table' Chart={LmpConsolidatedTable} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='Ancillary Services MCP' Chart={AncillaryServicesMCP} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='Sub-Regional Power Balance Binding Constraints' Chart={SubRegionalPowerBalanceBindingConstraints} showPopout={true} hideDisclaimer={true} />
					</div>
					<div className='column-2'>
						<Pod title='Reserve Products Binding Constraints' Chart={ReserveProductsBindingConstraints} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='Real Time RSG Commitments' Chart={RealTimeRSGCommitments} showPopout={true} hideDisclaimer={true} />
					</div>
					<div className='column-2'>
						<Pod title='Coordinated Transaction Scheduling' Chart={CoordinatedTransactionScheduling} showPopout={true} hideDisclaimer={true} />
					</div>
				</div>
			</div>
			<Disclaimer extraMargin={true} />
			<br></br>
		</>
	);
}
